// Web Audio API sound effects — no external files needed
const audioCtx =
  typeof window !== 'undefined'
    ? new (window.AudioContext || (window as any).webkitAudioContext)()
    : null

function ensureContext() {
  if (audioCtx && audioCtx.state === 'suspended') {
    audioCtx.resume()
  }
}

export function playSuccess() {
  ensureContext()
  if (!audioCtx) return

  const now = audioCtx.currentTime

  // Bright ascending chime — three notes
  const frequencies = [523.25, 659.25, 783.99] // C5, E5, G5
  frequencies.forEach((freq, i) => {
    const osc = audioCtx.createOscillator()
    const gain = audioCtx.createGain()
    osc.connect(gain)
    gain.connect(audioCtx.destination)
    osc.type = 'sine'
    osc.frequency.value = freq
    gain.gain.setValueAtTime(0, now + i * 0.12)
    gain.gain.linearRampToValueAtTime(0.3, now + i * 0.12 + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.12 + 0.5)
    osc.start(now + i * 0.12)
    osc.stop(now + i * 0.12 + 0.5)
  })

  // Final sparkle
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.connect(gain)
  gain.connect(audioCtx.destination)
  osc.type = 'sine'
  osc.frequency.value = 1046.5 // C6
  gain.gain.setValueAtTime(0, now + 0.4)
  gain.gain.linearRampToValueAtTime(0.2, now + 0.42)
  gain.gain.exponentialRampToValueAtTime(0.001, now + 1.0)
  osc.start(now + 0.4)
  osc.stop(now + 1.0)
}

export function playWrong() {
  ensureContext()
  if (!audioCtx) return

  const now = audioCtx.currentTime

  // Descending buzzer — two low tones
  const frequencies = [311.13, 233.08] // Eb4, Bb3
  frequencies.forEach((freq, i) => {
    const osc = audioCtx.createOscillator()
    const gain = audioCtx.createGain()
    osc.connect(gain)
    gain.connect(audioCtx.destination)
    osc.type = 'sawtooth'
    osc.frequency.value = freq
    gain.gain.setValueAtTime(0, now + i * 0.2)
    gain.gain.linearRampToValueAtTime(0.25, now + i * 0.2 + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.2 + 0.4)
    osc.start(now + i * 0.2)
    osc.stop(now + i * 0.2 + 0.4)
  })
}

export function playReveal() {
  ensureContext()
  if (!audioCtx) return

  const now = audioCtx.currentTime
  // Drum roll effect — rapid soft taps
  for (let i = 0; i < 8; i++) {
    const osc = audioCtx.createOscillator()
    const gain = audioCtx.createGain()
    osc.connect(gain)
    gain.connect(audioCtx.destination)
    osc.type = 'triangle'
    osc.frequency.value = 200 + i * 30
    const t = now + i * 0.06
    gain.gain.setValueAtTime(0, t)
    gain.gain.linearRampToValueAtTime(0.1 + i * 0.02, t + 0.01)
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.08)
    osc.start(t)
    osc.stop(t + 0.08)
  }
}
